import { updateOffsetByProjectVsp, useAppDispatch } from '@core/core/store'
import type { ProjectId } from 'common/types'
import type { FC } from 'react'

import { useStepController } from '../components'
import type { OnChangeVspOffsetFunc } from '../types'
import { isValidInteger } from '../types'
import { StepApplyVsp } from './StepApplyVsp'
import { StepChooseBaseWell } from './StepChooseBaseWell'
import { StepChooseTargetWells } from './StepChooseTargetWells'
import { StepChooseVsp } from './StepChooseVsp'
import { StepChooseWellWithVsp } from './StepChooseWellWithVsp'
import { StepWellVspSettings } from './StepWellVspSettings'

type StepsProps = {
  projectId: ProjectId
}

export const Steps: FC<StepsProps> = ({ projectId }) => {
  const { activeStep } = useStepController()

  const dispatch = useAppDispatch()

  const onChangeVspOffset: OnChangeVspOffsetFunc = (projectVspId, wellId) => offset => {
    if (isValidInteger(offset)) {
      dispatch(updateOffsetByProjectVsp(projectVspId, wellId, projectId, offset))
    }
  }

  switch (activeStep.id) {
    case 'chooseBaseWell':
      return <StepChooseBaseWell onChangeVspOffset={onChangeVspOffset} />
    case 'wellVspSettings':
      return <StepWellVspSettings projectId={projectId} onChangeVspOffset={onChangeVspOffset} />
    case 'chooseWellWithVsp':
      return <StepChooseWellWithVsp />
    case 'chooseVsp':
      return <StepChooseVsp projectId={projectId} />
    case 'applyVsp':
      return <StepApplyVsp onChangeVspOffset={onChangeVspOffset} />
    case 'chooseTargetWells':
      return <StepChooseTargetWells projectId={projectId} />
  }
}
